<script lang="ts">
  // Dark inset input with a cyan underline that lights up on focus.
  let {
    value = $bindable(""),
    type = "text",
    placeholder = "",
    autocomplete,
    id,
    maxlength,
    onkeydown,
  }: {
    value?: string;
    type?: "text" | "password";
    placeholder?: string;
    autocomplete?: AutoFill;
    id?: string;
    maxlength?: number;
    onkeydown?: (e: KeyboardEvent) => void;
  } = $props();
</script>

<input
  {id}
  {type}
  {placeholder}
  {autocomplete}
  {maxlength}
  {onkeydown}
  bind:value
  class="w-full border-b-2 border-cyan-dim/50 bg-void-2/60 px-3 py-2 font-body text-ink caret-cyan outline-none transition-colors duration-200 placeholder:text-ink-dim/50 focus:bg-void-2/80"
/>

<style>
  /* Focus underline sweeps open from the centre (over the resting border). */
  input {
    background-image: linear-gradient(var(--color-cyan), var(--color-cyan));
    background-size: 0% 2px;
    background-position: 50% 100%;
    background-repeat: no-repeat;
    transition:
      background-size 0.3s var(--ease-out-quint),
      background-color 0.2s;
  }
  input:focus {
    background-size: 100% 2px;
  }
  @media (prefers-reduced-motion: reduce) {
    input {
      transition: none;
    }
  }
</style>
